import { REPORT_VIDEO_DURATION, SEND_CODE_API, CAPTCHA_INFO_API } from '@constants/api';
import _axios from '@plugins/_axios';
import { ajax } from '@helpers/ajax';
import store from '@/store';

/**
 * 获取图形验证码
 * @param {String} cellphone 手机号码
 * @param {Number} type 验证码类型
 * @param {Number} role 角色
 */
export function captchaInfo() {
    return _axios.post(CAPTCHA_INFO_API);
}

/**
 * 发送验证码
 * @param {String} cellphone 手机号码
 * @param {String} captcha 图形验证码
 * @param {String} session_id 图形验证码session_id
 * @param {Number} type 验证码类型
 * @param {Number} role 角色
 */
// eslint-disable-next-line max-params
export function sendSms(cellphone, captcha, session_id, type = 1, role = 1) {
    return _axios.post(SEND_CODE_API, {
        cellphone,
        captcha,
        session_id,
        type,
        role
    });
}

/**
 * 统计用户看视频时间
 * @param schedule_id 计划ID
 * @param duration 持续时间
 * @param start_time 开始时间
 * @param p 平台
 */
export function reportVideoTime({ schedule_id, duration, start_time, p = 'PC' }) {
    ajax({
        method: 'POST',
        url: process.env.VUE_APP_API_URL + REPORT_VIDEO_DURATION,
        body: `schedule_id=${encodeURIComponent(schedule_id)}&duration=${encodeURIComponent(
            duration
        )}&start_time=${encodeURIComponent(start_time)}&p=${encodeURIComponent(p)}`,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${store.getters.token}`
        }
    });
}
